import { BaseService } from './baseService';
import { PatientImplantDto, PatientImplantFormData } from '../types/patientImplant';
import { PatientAllergyFormData } from '../types/patientAllergy';

class PatientImplantService extends BaseService<PatientImplantDto, PatientImplantFormData> {
    constructor() {
        super('/PatientImplant');
    }
}

export const patientImplantService = new PatientImplantService();